export const firebaseConfig = {
  apiKey: "AIzaSyAuvu2QGJV9hJl7hoyM0EHUDAlfW6rbtfk",
  authDomain: "family-tree-prints.firebaseapp.com",
  databaseURL: "https://family-tree-prints.firebaseio.com",
  projectId: "family-tree-prints",
  storageBucket: "family-tree-prints.appspot.com",
  messagingSenderId: "98865994389"
};



// WEBPACK FOOTER //
// ./src/core/firebase/config.js